import styled from 'styled-components'

export const Wrapper = styled.main`
  margin: 20px 15px;
  width: 100%;
  max-width: 958px;
  margin: auto;
  padding: 32px 0;
`
